export const VITE_POSTHOG_API_KEY: string = import.meta.env
  .VITE_POSTHOG_API_KEY;
export const POSTHOG_API_HOST: string = import.meta.env.VITE_POSTHOG_API_HOST;
